import { memo } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { FullHeightOnly } from '../../components/shared/Grid';
import TemplateDefault from '../../layout/TemplateDefault';
import { StyledTabs, StyledTab } from './styled';
import Journeys from '../Journeys';
import MyFilesV2 from '../MyFilesV2';
import ExamsV2 from '../ExamsV2';
import { FileCategoryPageContent } from '../FileCategoryPage';
import { ExamCategoryPageContent } from '../ExamsV2/ExamCategoryPage';
import HomeV2ViewModel from './viewModel';
import { TAB_PATHS } from './model';

type TabItem = {
  label: string;
  path: string;
  component: React.ReactNode;
};

const TABS: TabItem[] = [
  { label: 'Jornadas', path: TAB_PATHS[0], component: <Journeys /> },
  { label: 'Arquivos', path: TAB_PATHS[1], component: <MyFilesV2 /> },
  { label: 'Exames', path: TAB_PATHS[2], component: <ExamsV2 /> },
];

// Wrapper memoizado para que os filhos não re-renderizem quando o pai (HomeV2) re-renderiza.
// Como TABS é module-level, tab.component é sempre a mesma referência — memo faz bail-out.
const StableTabContent = memo(function StableTabContent({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
});

export default function HomeV2() {
  const { value, handleChange, showTabs, showFileCategoryPage, showExamCategoryPage } = HomeV2ViewModel();

  return (
    <>
      <TemplateDefault>
        <FullHeightOnly>
          <Grid container>
            <Grid item xs={0} sm={1} md={3}></Grid>
            <Grid item xs={12} sm={10} md={6}>
              <Box sx={{ display: showTabs ? 'block' : 'none' }}>
                <StyledTabs
                  value={value}
                  onChange={handleChange}
                  centered
                  TabIndicatorProps={{ style: { height: '4px', borderRadius: '2px' } }}
                >
                  {TABS.map((tab, index) => (
                    <StyledTab
                      key={tab.path}
                      id={`tab-${index}`}
                      aria-controls={`tabpanel-${index}`}
                      label={tab.label}
                      disableRipple
                    />
                  ))}
                </StyledTabs>

                {TABS.map((tab, index) => (
                  <Box
                    key={tab.path}
                    role="tabpanel"
                    id={`tabpanel-${index}`}
                    aria-labelledby={`tab-${index}`}
                    sx={{ display: value === index ? 'block' : 'none', py: 3 }}
                  >
                    <StableTabContent>{tab.component}</StableTabContent>
                  </Box>
                ))}
              </Box>

              {showFileCategoryPage && <FileCategoryPageContent />}
              {showExamCategoryPage && <ExamCategoryPageContent />}
            </Grid>
            <Grid item xs={0} sm={1} md={3}></Grid>
          </Grid>
        </FullHeightOnly>
      </TemplateDefault>
    </>
  );
}
